module.exports = __webpack_public_path__ + "img/lock.3a2872d0.svg";